import React, { useState } from 'react'
import axios from "axios";

// import Files
import * as Config from "../Utils/Config";
import { header } from "../Utils/ApiHeader";



// UPDATE_PANEL_THEME
export async function UPDATE_PanelName(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}updateThemeBysuperadmin`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {

    }

}

